<template>
  <div class="contents contents--pt">
    <section class="_pt-md">
      <log-write-modal
        :key="logRecord"
        :day="today"
        :is-open="isOpenWriteModal"
        @close="closeModalWrite"
      />
      <log-graph-modal :is-open="isOpenGraphModal" @close="isOpenGraphModal = false" />
      <div class="inner">
        <div class="Log__area">
          <div class="Log__side">
            <div
              class="Log__record_btn"
              data-modal-open="log-1"
              @click="OpenWriteModal"
            >
              <span>ログを記録</span>
            </div>
          </div>
          <log-chart :key="logRecord" log-main-class="Log__main--lg" />
        </div>
        <div class="Btn__area">
          <div
            class="Btn__line Btn__line--mgt-lg _ft-spacing120"
            data-modal-open="log-4"
            @click="isOpenGraphModal = true"
          >
            グラフのおすすめ活用法を見る
          </div>
        </div>
      </div>
    </section>
    <section>
      <log-calendar :key="logRecord" @reload="reloadComponent" />
    </section>
  </div>
</template>
<script>

import LogChart from '@/views/components/Log/LogChart'
import LogCalendar from '@/views/pages/log/components/LogCalendar'
import LogWriteModal from '@/views/pages/log/components/LogWriteModal'
import LogGraphModal from '@/views/pages/log/components/LogGraphModal'
import moment from 'moment'

export default {
  name: 'Log',
  components: { LogCalendar, LogChart, LogWriteModal, LogGraphModal },
  data() {
    return {
      isOpenWriteModal: false,
      isOpenGraphModal: false,
      logRecord: 0,
      today: ''
    }
  },
  methods: {
    OpenWriteModal() {
      const day = new Date()
      this.today = moment(day).format('Y-M-DD')
      this.isOpenWriteModal = true
    },
    reloadComponent(type) {
      this.isOpenWriteModal = false
      if (type === 'updated') {
        this.logRecord++
      }
    },
    closeModalWrite(type) {
      this.isOpenWriteModal = false
      if (type === 'updated') {
        this.logRecord++
      }
    }
  }
}
</script>
